import { Button, ButtonGroup, Card, Grid, makeStyles, Paper, TextField, Typography } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useDispatch } from 'react-redux';
import { HeaderBlock } from "../../components/header-block/HeaderBlock";
import { Loading } from "../../components/loading/Loading";
// Styles
import PageContainer from "../../components/page-container/PageContainer";
import { PagePlaceholder } from "../../components/page-placeholder/PagePlaceholder";
import { getIcon } from "../../icon/icon";
import { getProductAvailability } from "../../state/actions/ProductAvailabilityAction";
import HelpCard from "../../components/help-card/HelpCard";
import { useTranslation } from "react-i18next";


const useStyles = makeStyles({
    container: {
        padding: "30px"
    },

    card: {
        padding: "15px"
    }
})

export default function ProductAvailabilityPage(props) {

    const styles = useStyles()
    const [t, i18n] = useTranslation()

    const [loading, setLoading] = useState(false)
    const [file, setFile] = useState(null)
    const [dialogOpen, setDialogOpen] = useState(false)
    const dispatch = useDispatch();
    const [newData, setNewData] = useState(false)
    const [customerId, setCustomerId] = useState("")
    const [productId, setProductId] = useState("")
    const [data, setData] = useState(null)

    function performAvailabilityFetch() {
        setLoading(true)
        dispatch(getProductAvailability(customerId, productId, (data) => {
            console.log("Order retrieved")
            setData(data)
            setNewData(true)
            setLoading(false)
        }))
    }

    return (
        <div className={styles.contentGrid}>
            <HeaderBlock
                title={t('product-availability.product-availability')}
                right={
                    <Grid container spacing={2} alignItems="center" justify="flex-end">
                        <Grid item>
                            <TextField
                                onChange={(event) => { setProductId(event.target.value) }}
                                label={t('product.product-id')}
                                variant="outlined"
                                margin="dense"
                                value={productId}
                            />
                        </Grid>
                        <Grid item>
                            <TextField
                                onChange={(event) => { setCustomerId(event.target.value) }}
                                label={t('customer.customer-id')}
                                variant="outlined"
                                margin="dense"
                                value={customerId}
                            />
                        </Grid>
                        <Grid item>
                            <ButtonGroup>
                                <Button
                                    variant="outlined"
                                    color="secondary"
                                    onClick={performAvailabilityFetch}
                                >
                                    {t('product-availability.product-availability')}
                        </Button>
                            </ButtonGroup>
                        </Grid>
                    </Grid>
                }
            />
            <HelpCard
                message={t('product-availability.check-product')}
            />
            <PageContainer hasHelp>

                <Grid container spacing={3} className={styles.container}>
                    <Grid item xs="12">
                        <Card className={styles.card}>
                            {data == null ? <PagePlaceholder
                                image={getIcon("support.svg")}
                                text={t('product-availability.input-for-availability')}
                            /> :
                                <Typography variant="h6">
                                    {
                                        loading ?
                                            <Loading /> :
                                            <pre>
                                                {JSON.stringify(data, null, 4)}
                                            </pre>
                                    }
                                </Typography>}
                        </Card>
                    </Grid>
                </Grid>
            </PageContainer>
        </div>
    );
}
